





















import { Component } from 'vue-property-decorator'
import { mixins } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'
import { Products } from '@one/types'
import CurrentProductMixin from '~/mixins/CurrentProduct'

const products = namespace('products')

interface Relation {
  [key: string]: string
}

interface RelationOptions {
  key: string
  label: string
}

@Component
export default class OneProductRelations extends mixins<CurrentProductMixin>(CurrentProductMixin) {
  @products.Getter getAttributesValue: any
  @products.Action fetchProduct: any

  relationLength(relation: Relation): boolean {
    // If length is less than 4, then display relations with blocks
    return Object.keys(relation).length < 4
  }

  relationsSelect(relation: Relation): Array<RelationOptions> {
    const relationKeys = Object.keys(relation)
    const relationValues = Object.values(relation)
    return relationKeys.map((item, index) => {
      return {
        key: item,
        label: relationValues[index],
      }
    })
  }

  async onRelationClick(relationIndex: string) {
    const product: Products.Product = await this.fetchProduct(relationIndex)
    this.$router.push(this.$routes.getProductPath(product))
  }
}
